
function Footer(){
    return(
        <div className="container-fluid p-1 border position-fixed bottom-0" style={{backgroundColor:"#47D3CE",color:"#f5f5f5" }}>
    
                <p className="text-center m-0" style={{fontSize:"12px"}}>GPA CONVERTER | DEVELOPED BY <a href="https://umendrapardhi.web.app" style={{textDecoration: "none",color: '#ffffff'}} target='_blank'>UMENDRA PARDHI</a></p>

        </div>
    )
}
export default Footer;